

import sjcl from '../../../vendor/sjcl';
import requestConfig from './request-config';
import coreConfig from '../../core-config';

export default class Request {
  constructor() {
    this.config = requestConfig;
  }

  parseConfig(config) {
    config = Object.assign({}, this.config, config);
    config.parameters.ajax = new Date().getTime();
    const keys = Object.keys(config.parameters);

    if (keys.length > 0) {
      config.path += '?';
    }

    keys.forEach((key) => {
      config.path += `${key}=${config.parameters[key]}&`;
    });

    if (keys.length > 0) {
      config.path = config.path.substr(0, config.path.length - 1);
    }

    if (config.host && config.basePath) {
      config.url = config.host + config.basePath + config.path;
    } else {
      config.url = coreConfig.apiUrl + config.path;
    }

    if (typeof config.postData === 'object' && config.postData !== null) {
      config.postData = JSON.stringify(config.postData);
      config.contentType = 'application/json';
    }

    if (!config.method) {
      config.method = (config.postData === null) ? 'GET' : 'POST';
    }
    return config;
  }

  makeRequest(config) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      config = this.parseConfig(config);
      xhr.open(config.method, config.url);
      xhr.timeout = config.defaultTimeout;
      if (config.method === 'POST') {
        xhr.setRequestHeader('Content-Type', config.contentType);
      }

      if (config.hmacId && config.hmacSecret) {
        Request.calcHMAC(xhr, config);
      }

      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4 && xhr.status >= 200 && xhr.status < 300) {
          let parsedResponse;
          try {
            parsedResponse = JSON.parse(xhr.responseText);
          } catch (e) {
            resolve(xhr.responseText);
          }
          resolve(parsedResponse);
        } else if (xhr.readyState === 4) {
          reject(xhr.statusText);
        }
      };

      xhr.send(config.postData);
    });
  }

  setHeaders(httpRequest) {
    const keys = this.headers.keys();
    keys.forEach(key => httpRequest.setRequestHeader(key, this.headers[key]));
  }

  static calcHMAC(xhr, config) {
    let message = config.method + coreConfig.apiPrefix + config.path;
    if (config.postData) {
      message += config.postData;
    }
    const key = sjcl.codec.utf8String.toBits(config.hmacSecret);
    // eslint-disable-next-line new-cap
    const digest = (new sjcl.misc.hmac(key, sjcl.hash.sha256))
      .mac(sjcl.codec.utf8String.toBits(message));
    const header = `${config.hmacId}//${sjcl.codec.hex.fromBits(digest)}`;
    xhr.setRequestHeader('HMAC', header);
  }
}
